import AEMWrapper from "aem/ComponentWrapper";
import loadable from "@loadable/component";
import meta from "./aem-meta";
import React from "react";
import memoize from "utils/memoize";

const Component = loadable(
  () =>
    import(
      /* webpackChunkName: "component-rh-quicklinks/aem-component" */ "./aem-component"
    ),
  {
    fallback: <></>
  }
);
export default memoize(AEMWrapper(meta, Component));
